import {
  CONSTRUCTION_DASHBOARD_FAILURE,
  CONSTRUCTION_DASHBOARD_LOADING,
  CONSTRUCTION_DASHBOARD_SUCCESS,
} from "../../actions/types";

const INITIAL_STATE = {
  loading: false,
  success: {
    ok: false,
    data: null,
  },
  failure: {
    error: false,
    message: "",
  },
};

const getConstructionDashboardReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSTRUCTION_DASHBOARD_LOADING:
      return {
        ...state,
        loading: true,
        success: {
          ok: false,
          data: null,
        },
        failure: {
          error: false,
          message: "",
        },
      };
    case CONSTRUCTION_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          ...state.success,
          ok: true,
          data: action.payload,
        },
        failure: {
          error: false,
          message: "",
        },
      };
    case CONSTRUCTION_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        success: {
          ...state.success,
          ok: false,
          data: null,
        },
        failure: {
          error: true,
          message: action.payload.message,
        },
      };
  }
  return state;
};

export default getConstructionDashboardReducers;
